import React from 'react';
import { motion } from 'framer-motion';
import { BookOpenIcon, UtensilsIcon, CheckSquareIcon, PillIcon, MessageSquareIcon } from 'lucide-react';
const deliverables = [{
  icon: BookOpenIcon,
  title: 'El Diario de Bio-Feedback Hormonal',
  desc: 'Identifica tus disparadores de ansiedad y calor en 48 horas.'
}, {
  icon: UtensilsIcon,
  title: 'Planner de Micro-ajustes Nutricionales',
  desc: 'El truco de la proteína matinal para eliminar la niebla mental.'
}, {
  icon: CheckSquareIcon,
  title: 'Checklist: Auditoría de Dormitorio Anti-Sofocos',
  desc: 'Configura tu entorno para dormir 7 horas seguidas.'
}, {
  icon: PillIcon,
  title: 'Guía de Suplementación Inteligente 40+',
  desc: 'Qué tomar (y qué evitar) para ahorrar dinero y ganar salud.'
}];
export function WhatYouGet() {
  return <section className="w-full bg-ivory py-20 md:py-32" data-id="element-111">
      <div className="max-w-6xl mx-auto px-6 lg:px-8" data-id="element-112">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.8
      }} className="text-center mb-16" data-id="element-113">
          <h2 className="text-3xl md:text-4xl font-serif text-text-brown tracking-wide mb-4" data-id="element-114">
            Lo que incluye tu Master-Kit
          </h2>
          <div className="w-24 h-[1px] bg-gold mx-auto" data-id="element-115"></div>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 lg:gap-8 mb-8" data-id="element-116">
          {deliverables.map((item, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-50px'
        }} transition={{
          duration: 0.5,
          delay: index * 0.1
        }} whileHover={{
          y: -5
        }} className="bg-white p-8 rounded-sm shadow-sm border border-taupe/20 flex flex-col sm:flex-row gap-6 items-start transition-all duration-300" data-id="element-117">
              <div className="p-3 bg-cream rounded-full text-terracotta flex-shrink-0" data-id="element-118">
                <item.icon className="w-6 h-6" strokeWidth={1.5} data-id="element-119" />
              </div>
              <div data-id="element-120">
                <h3 className="text-xl font-serif text-text-brown mb-2" data-id="element-121">
                  {item.title}
                </h3>
                <p className="text-text-brown-light font-light leading-relaxed" data-id="element-122">
                  {item.desc}
                </p>
              </div>
            </motion.div>)}
        </div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-50px'
      }} transition={{
        duration: 0.5,
        delay: 0.4
      }} whileHover={{
        y: -5
      }} className="bg-cream p-8 rounded-sm shadow-md border border-gold/30 flex flex-col sm:flex-row gap-6 items-start transition-all duration-300 relative overflow-hidden" data-id="element-123">
          <div className="absolute top-0 left-0 w-1 h-full bg-gold" data-id="element-124"></div>
          <div className="p-3 bg-gold/10 rounded-full text-gold flex-shrink-0" data-id="element-125">
            <MessageSquareIcon className="w-6 h-6" strokeWidth={1.5} data-id="element-126" />
          </div>
          <div data-id="element-127">
            <div className="text-xs font-bold tracking-widest text-gold uppercase mb-1" data-id="element-128">
              Bonus Exclusivo
            </div>
            <h3 className="text-xl font-serif text-text-brown mb-2" data-id="element-129">
              Scripts para tu Médico
            </h3>
            <p className="text-text-brown-light font-light leading-relaxed" data-id="element-130">
              Las palabras exactas para que te tomen en serio en tu próxima
              analítica.
            </p>
          </div>
        </motion.div>
      </div>
    </section>;
}